export default __webpack_public_path__ + "static/media/bannerBgMb.57e7f843.png";